import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import * as React from 'react'
import { connect } from 'react-redux'
import type { ButtonProps } from 'types/content-editor'
import type { Playlist } from 'types/playlist'
import { getPlaylists } from '@disco/state-management/selectors/playlists'
import { emailColors } from '@disco/utils/colors'
import { fixLink } from '@disco/utils/links'
import ButtonPropsView from 'components/common/rich-text-editor/toolbar/element-settings/button/view'

const mapStateToProps = state => {
  return {
    playlists: getPlaylists(state),
  }
}

class ButtonBlockSettings extends React.Component<
  {
    content: ButtonProps
    onChange: (arg0: Record<string, any>) => any
    playlists: Record<number, Playlist>
    validationErrors: Record<string, any>
  },
  null
> {
  _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = cloneDeep(this.props.content)
    set(value, e.target.name, e.target.value)

    if (e.target.name === 'link') {
      set(value, 'playlist_id', null)
      set(value, 'link', fixLink(e.target.value))
    }

    this.props.onChange(value)
  }
  _onColorChange = (prop: string, color: string) => {
    let value = cloneDeep(this.props.content)
    set(value, prop, color)
    this.props.onChange(value)
  }
  _onPlaylistSelect = (playlist_id: number) => {
    const value = {
      ...this.props.content,
      playlist_id,
      link: get(this.props.playlists[playlist_id], 'view_playlist_url', ''),
    }
    this.props.onChange(value)
  }

  render() {
    const { content, validationErrors } = this.props
    return (
      <div className="content-editor__button-block">
        <ButtonPropsView
          value={content}
          colors={emailColors}
          onChange={this._onChange}
          onColorChange={this._onColorChange}
          onPlaylistSelect={this._onPlaylistSelect}
          validationErrors={validationErrors}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, {})(ButtonBlockSettings) as any
